import { FormTemplate } from "components/modal/templates";
import { formatDate } from "helpers/date";
import React from "react";
import { alert } from "services/alert";
import { createRegistryUsingBids } from "sources/books/registries";
import { getBidsForRegistry } from "sources/books/universalTransferDocuments";
import { config, initialState } from "./config";

const parseIds = (value) =>
    `${value || ""}`
        .split(/[,\s]+/)
        .map((item) => parseInt(item))
        .filter((item) => !Number.isNaN(item));

class CreateRegistryForm extends FormTemplate {
    close = (data = false) => {
        this.setState({ isLoading: false });
        this.props.back?.(data);
    };

    render = () => this.renderBody();

    bidIds = () => {
        const ids = this.state.sourceMode === "search" ? this.state.selectedBidIds : parseIds(this.state.manualBidIds);
        return [...new Set(ids)];
    };

    setSourceMode = (sourceMode) => {
        this.setState({
            sourceMode,
            manualBidIds: "",
            selectedBidIds: [],
        });
    };

    searchBids = () => {
        const { counterpartyId, from, to } = this.state;
        if (!counterpartyId || !from || !to) {
            alert({ type: "warning", title: "Ошибка", message: "Выберите контрагента и период" });
            return;
        }
        this.setState({ loadingBids: true });
        getBidsForRegistry({ counterpartyId, from: formatDate(from), to: formatDate(to) })
            .then((res) => {
                const bids = res || [];
                this.setState({
                    bids,
                    selectedBidIds: bids.filter((item) => item.isSuitableForRegistry).map((item) => item.id),
                });
            })
            .finally(() => this.setState({ loadingBids: false }));
    };

    toggleBid = (id) => {
        const { selectedBidIds } = this.state;
        this.setState({
            selectedBidIds: selectedBidIds.includes(id)
                ? selectedBidIds.filter((item) => item !== id)
                : [...selectedBidIds, id],
        });
    };

    sendRequest = () => {
        const bidIds = this.bidIds();
        if (bidIds.length < 2) {
            alert({ type: "warning", title: "Ошибка", message: "Выберите или укажите минимум две заявки" });
            this.setState({ isLoading: false });
            return Promise.resolve(false);
        }

        return createRegistryUsingBids({
            bidIds,
            from: formatDate(this.state.from),
            to: formatDate(this.state.to),
        });
    };

    renderBids = () => {
        const { bids, loadingBids, selectedBidIds } = this.state;
        return (
            <div className={loadingBids ? "loading loading--small" : ""}>
                {!!bids.length && (
                    <div className="table-responsive">
                        <table className="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th />
                                    <th>ID</th>
                                    <th>Маршрут</th>
                                    <th>Сумма</th>
                                    <th>НДС</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bids.map((item) => (
                                    <tr key={item.id} className={!item.isSuitableForRegistry ? "text-muted" : ""}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedBidIds.includes(item.id)}
                                                disabled={!item.isSuitableForRegistry}
                                                onChange={() => this.toggleBid(item.id)}
                                            />
                                        </td>
                                        <td>{item.id}</td>
                                        <td>
                                            {item.from} - {item.to}
                                        </td>
                                        <td>{item.price}</td>
                                        <td>
                                            {item.vat === null || item.vat === undefined ? "Без НДС" : `${item.vat}%`}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    };

    renderSourceMode = () => {
        const { sourceMode } = this.state;
        const sourceModes = [
            { value: "search", label: "Через поиск" },
            { value: "manual", label: "Вручную" },
        ];
        return (
            <div className="row form-group">
                <div className="offset-sm-4 offset-md-3 col-sm-8 col-md-9">
                    <div className="btn-group btn-group-sm">
                        {sourceModes.map((item) => (
                            <button
                                key={item.value}
                                type="button"
                                className={`btn ${sourceMode === item.value ? "btn-brand" : "btn-secondary"}`}
                                onClick={() => this.setSourceMode(item.value)}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        );
    };

    renderManualIds = () => (
        <>
            {this.renderField(config.manualBidIds)}
            <div className="row form-group mt-n3">
                <div className="offset-sm-4 offset-md-3 col-sm-8 col-md-9">
                    <small className="text-muted">Можно указать несколько ID через запятую или пробел.</small>
                </div>
            </div>
        </>
    );

    renderSearch = () => (
        <>
            {this.renderSelect(config.counterpartyId)}
            <div className="row">
                <div className="col-sm-8 col-md-9 col-form-label-sm offset-sm-4 offset-md-3">
                    <div className="inline-btn inline-btn--without-icon mb-3" onClick={this.searchBids}>
                        Найти заявки
                    </div>
                </div>
            </div>
            {this.renderBids()}
        </>
    );

    renderBodyInner = () => (
        <>
            {this.renderSourceMode()}
            {this.renderDateField(config.from)}
            {this.renderDateField(config.to)}
            {this.state.sourceMode === "search" ? this.renderSearch() : this.renderManualIds()}
        </>
    );

    renderActionSend = () => {
        const cname = "btn btn-brand btn-sm modal-window__footer-action";
        return <input type="submit" className={cname} value="Создать реестр" />;
    };
}

export default function ConfiguredCreateRegistryForm(props) {
    return <CreateRegistryForm {...props} config={config} initialState={initialState} />;
}
